<template>
    <start-screen id="start"/>
    <news-screen v-if="$isMobile"/>
    <about-screen id="advantages"/>
    <catalog-screen class="watch-block" id="catalog"/>
    <div class="screens-white-wrapper">
      <history-screen-new class="watch-block" id="about"/>
      <service-screen class="watch-block" id="service"/>
<!--      <case-screen id="case"/>-->
      <materials-screen  id="material"/>
    </div>
    <career-screen  class="watch-block" id="career"/>
</template>

<script>
import StartScreen from "@/components/features/StartScreen.vue";
import AboutScreen from "@/components/features/AboutScreen.vue";
import CatalogScreen from "@/components/features/CatalogScreen.vue";
import HistoryScreen from "@/components/features/HistoryScreen.vue";
import ServiceScreen from "@/components/features/ServiceScreen.vue";
import CaseScreen from "@/components/features/CaseScreen.vue";
import MaterialsScreen from "@/components/features/MaterialsScreen.vue";
import CareerScreen from "@/components/features/CareerScreen.vue";
import NewsScreen from "@/components/features/NewsScreen.vue";
import HistoryScreenNew from "@/components/features/HistoryScreenNew.vue";

export default {
  name: "main-page",
  components: {
    HistoryScreenNew,
    NewsScreen,
    CareerScreen,
    MaterialsScreen, CaseScreen, ServiceScreen, HistoryScreen, CatalogScreen, AboutScreen, StartScreen},
  mounted() {
    this.mountedAction();
  },
  methods: {
    mountedAction() {
        this.IS_SCROLL_PARENT(true);
        let rout = this.$route.name;
        this.scrollToBlockStatic(rout, false)
    }
  }
}
</script>

<style scoped>
.screens-white-wrapper {
  background-color: var(--color-white);
}
</style>